import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { ImportResult } from '@shared/classes/import-result';
import { DataGridComponent } from '@shared/components/smart-data-grid/data-grid/data-grid.component';
import { ImportResultDataGridColumnDef } from './import-data-result.constant';
import { ImportDataResultDataGridCell } from '@app/shared/components/smart-data-grid/data-grid-cell-templates/import-data-result-data-grid-cell.component';
import { GroupByHelper } from '@app/shared/utils/group-by.helper';
import { CommonFieldName } from '@app/shared/constants';

@Component({
  selector: 'app-import-data-result',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatDialogModule, DataGridComponent, ImportDataResultDataGridCell],
  templateUrl: './import-data-result.component.html',
  styleUrl: './import-data-result.component.css'
})
export class ImportDataResultComponent implements OnInit {
  importResultDataGridColumnDef = ImportResultDataGridColumnDef;

  dataSource$: Observable<ImportResult[]>;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public importResponse: ImportResult[]) { }

  ngOnInit() {
    this.dataSource$ = of(GroupByHelper.sortArray(this.importResponse, CommonFieldName.sheetName, true));
  }
}
